// extracted by mini-css-extract-plugin
export default {"userTypeSelection":"UserTypeSelection_userTypeSelection__0ipv4","image":"UserTypeSelection_image__ZNkHI","card":"UserTypeSelection_card__NPE4k"};